import { render } from "./AllMessagesView.vue?vue&type=template&id=657b0dbf"
import script from "./AllMessagesView.vue?vue&type=script&lang=js"
export * from "./AllMessagesView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__